import { useQuery } from 'react-query';
import TradeListService from '../../../services/TradeListService';
import { TRADE } from '../../constants/queryDefinition';

const tradeListService = TradeListService.get();

export default function useTradeMetaData() {
  async function getTradeMetaData() {
    const tradeMetaDataResponse = await tradeListService.getMetaData();

    return tradeMetaDataResponse;
  }

  const tradeMetaData = useQuery(
    TRADE.CREATEMETADATA.KEY,
    getTradeMetaData,
    {}
  );

  return tradeMetaData;
}
